import { render } from "./password-reset.vue?vue&type=template&id=2d2eac0e"
import script from "./password-reset.vue?vue&type=script&lang=js"
export * from "./password-reset.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__